import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UserPreference } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchUserPreferencesParams } from '../api';
import { createUserPreferenceApi, userPreferenceKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseUserPreferencesOptions {
  /** Gates the query, e.g. while an upstream eligibility check is still resolving. Defaults to
   * `true` (always enabled), matching every existing caller. */
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUserPreferences(
  params: SearchUserPreferencesParams,
  options: UseUserPreferencesOptions = {},
): UseQueryResult<UserPreference[]> {
  const { enabled = true } = options;
  const client = useApiClient('admin-auth');
  const api = createUserPreferenceApi(client);

  return useQuery({
    enabled,
    queryFn: (): Promise<UserPreference[]> => api.searchUserPreferences(params),
    queryKey: userPreferenceKeys.list(params),
  });
}
